"use client";

import { useEffect, useMemo, useState } from "react";

import type { Sku, UseProductItemProps } from "../ongs.types";

export function useProductItem({
  skus,
  clusterHighlights,
  status,
  disableClusterHighlights = false
}: UseProductItemProps) {
  const matchingSKU = useMemo(() => {
    return skus?.find(
      (sku) => sku.bestChoice && sku.seller.status === "AVAILABLE"
    );
  }, [skus]);

  const defaultSku: Sku = useMemo(() => skus[0], [skus]);

  const [isSelectedSkuAvailable, setIsSelectedSkuAvailable] = useState<boolean>(
    matchingSKU?.seller.status === "AVAILABLE"
  );

  const [selectedSku, setSelectedSku] = useState<Sku>(
    skus && matchingSKU ? matchingSKU : defaultSku
  );

  const isUnavailable = status === "UNAVAILABLE";

  useEffect(() => {
    setIsSelectedSkuAvailable(matchingSKU?.seller.status === "AVAILABLE");
    setSelectedSku(skus && matchingSKU ? matchingSKU : defaultSku);
  }, [matchingSKU, skus, setIsSelectedSkuAvailable, defaultSku]);

  useEffect(() => {
    setIsSelectedSkuAvailable(selectedSku.seller.status === "AVAILABLE");
  }, [selectedSku, setIsSelectedSkuAvailable]);

  const renderClusterHighlights = useMemo(() => {
    if (!clusterHighlights || !!disableClusterHighlights) return false;
    return true;
  }, [clusterHighlights, disableClusterHighlights]);

  return {
    isSelectedSkuAvailable,
    renderClusterHighlights,
    isUnavailable,
    selectedSku,
    setSelectedSku
  };
}
